import React from 'react';
import './TJHTheme.scss';

const TJHTheme = () => (
  <div className="product-hero-decoration" aria-hidden="true">
    <div className="product-hero-stars" />
    <div className="product-hero-decoration--left">
      <div className="product-hero-planet" />
      <div className="product-hero-alien" />
      <div className="product-hero-earth" />
    </div>
    <div className="product-hero-decoration--right">
      <div className="product-hero-planet" />
      <div className="product-hero-cadette" />
      <div className="product-hero-cadette-smoke" />
      <div className="product-hero-earth" />
    </div>
  </div>
);

export default TJHTheme;



// WEBPACK FOOTER //
// ./src/client/js/view/components/ProductHero/Theme/TJH/index.js